module.exports = __webpack_public_path__ + "static/fonts/DINAlternateBold.2dbc231e.ttf";